import React from "react";
import { Shield, Sparkles } from "lucide-react";

const TOOLTIP_VERIFIED =
  "Trusted TREL Concierges complete identity verification and TREL Certified Training before delivering experiences — helping create a safer, more trusted marketplace.";

const TOOLTIP_PLUS =
  "TREL+ Provider is an active premium growth membership ($29/mo) for enhanced visibility, AI matching, advanced analytics, and host network advantage.";

/**
 * VerifiedBadge — Ocean AI Blue trust badge. Native title tooltip explains meaning on hover.
 * Two sizes via the `size` prop ("sm" matches existing inline usage on ExperienceCard / ExperienceDetail; "md" matches dashboard usage).
 */
export function VerifiedBadge({ size = "sm", className = "" }) {
  const dims = size === "md"
    ? "text-xs px-2 py-0.5"
    : "text-[10px] px-2 py-0.5";
  return (
    <span
      title={TOOLTIP_VERIFIED}
      aria-label={TOOLTIP_VERIFIED}
      data-testid="badge-verified"
      className={`rounded-full inline-flex items-center gap-1 bg-[#00AEEF] text-[#FFF8EE] cursor-help ${dims} ${className}`}
    >
      <Shield size={size === "md" ? 11 : 10}/> TREL Verified
    </span>
  );
}

export function TrelPlusBadge({ size = "sm", label = "TREL+ Provider", className = "" }) {
  const dims = size === "md"
    ? "text-xs px-2 py-0.5"
    : "text-[10px] px-2 py-0.5";
  return (
    <span
      title={TOOLTIP_PLUS}
      aria-label={TOOLTIP_PLUS}
      data-testid="badge-trel-plus"
      className={`verified-gold rounded-full inline-flex items-center gap-1 font-semibold cursor-help ${dims} ${className}`}
    >
      <Sparkles size={size === "md" ? 11 : 10}/> {label}
    </span>
  );
}

export { TOOLTIP_VERIFIED, TOOLTIP_PLUS };
